import create from "zustand"

const initialState = {
  layoutType: "vertical",
  layoutWidth: "fluid",
  leftSideBarTheme: "dark",
  leftSideBarThemeImage: "none",
  leftSideBarType: "default",
  topbarTheme: "light",
  isPreloader: false,
  showRightSidebar: false,
  isMobile: false,
  showSidebar: true,
  leftMenu: false,
}

const layoutStore = create(set => ({
  ...initialState,
  changeLayout: layout => set({ layoutType: layout }),
  changeLayoutWidth: width => set({ layoutWidth: width }),
  changeSidebarTheme: theme => set({ leftSideBarTheme: theme }),
  changeSidebarThemeImage: themeimage =>
    set({ leftSideBarThemeImage: themeimage }),
  changeSidebarType: sidebarType => set({ leftSideBarType: sidebarType }),
  changeTopbarTheme: topbarTheme => set({ topbarTheme }),
  showRightSidebar: isopen => set({ showRightSidebar: isopen }),
  showSidebar: isopen => set({ showSidebar: isopen }),
  toggleLeftmenu: isopen => set({ leftMenu: isopen }),
  changePreloader: layout => set({ isPreloader: layout }),
}))

export default layoutStore
